@let hasValidationErrors = hasErrors();
<div class="soft-ds-date-range-input-root">
  @if (label()) {
    <label
      soft-ds-label
      [for]="fromControlId()"
      [required]="required()"
      [disabled]="disabled()"
    >
      {{ label() }}
    </label>
  }
  <div class="soft-ds-date-range-input-group">

    <div class="soft-ds-date-range-input-field">
      <input
        class="soft-ds-date-range-input-control"
        [id]="fromControlId()"
        [value]="fromInput() ?? (from() | format: format())"
        (input)="onEndpointInput('from', fromElement.value)"
        (change)="onEndpointChange('from', fromElement.value)"
        #fromElement
        (blur)="onEndpointBlur()"
        [readOnly]="readonly() || disabled()"
        [attr.name]="name() ? name() + '.from' : null"
        [attr.aria-invalid]="isInvalid() || null"
        [attr.aria-busy]="pending() || null"
        [attr.aria-readonly]="readonly() || null"
        [attr.aria-required]="required() || null"
        [attr.aria-disabled]="disabled() || null"
        [placeholder]="fromPlaceholder() | translate"
      />
      @if (canOpenPicker()) {
        <button
          type="button"
          class="soft-ds-date-range-input-trigger"
          aria-label="Startdatum wählen"
          (click)="openNativePicker(fromPicker)"
        >
          <soft-ds-icon name="fa-regular fa-calendar-day" />
        </button>
        <input
          #fromPicker
          type="date"
          class="soft-ds-date-range-input-native-picker"
          tabindex="-1"
          aria-hidden="true"
          [value]="fromPickerValue() ?? ''"
          (change)="onNativePicked('from', fromPicker.value)"
        />
      }
      @if (disabled()) {
        <soft-ds-icon
          class="soft-ds-date-range-input-state-icon"
          name="fa-regular fa-ban"
        />
      }
      @if (readonly()) {
        <soft-ds-icon
          class="soft-ds-date-range-input-state-icon"
          name="fa-regular fa-lock"
        />
      }
    </div>

    <span class="soft-ds-date-range-input-separator" aria-hidden="true">
      <soft-ds-icon name="fa-regular fa-minus" />
    </span>

    <div class="soft-ds-date-range-input-field">
      <input
        class="soft-ds-date-range-input-control"
        [id]="toControlId()"
        [value]="toInput() ?? (to() | format: format())"
        (input)="onEndpointInput('to', toElement.value)"
        (change)="onEndpointChange('to', toElement.value)"
        #toElement
        (blur)="onEndpointBlur()"
        [readOnly]="readonly() || disabled()"
        [attr.name]="name() ? name() + '.to' : null"
        [attr.aria-invalid]="isInvalid() || null"
        [attr.aria-busy]="pending() || null"
        [attr.aria-readonly]="readonly() || null"
        [attr.aria-required]="required() || null"
        [attr.aria-disabled]="disabled() || null"
        [placeholder]="toPlaceholder() | translate"
      />
      @if (canOpenPicker()) {
        <button
          type="button"
          class="soft-ds-date-range-input-trigger"
          aria-label="Enddatum wählen"
          (click)="openNativePicker(toPicker)"
        >
          <soft-ds-icon name="fa-regular fa-calendar-day" />
        </button>
        <input
          #toPicker
          type="date"
          class="soft-ds-date-range-input-native-picker"
          tabindex="-1"
          aria-hidden="true"
          [value]="toPickerValue() ?? ''"
          (change)="onNativePicked('to', toPicker.value)"
        />
      }
      @if (disabled()) {
        <soft-ds-icon
          class="soft-ds-date-range-input-state-icon"
          name="fa-regular fa-ban"
        />
      }
      @if (readonly()) {
        <soft-ds-icon
          class="soft-ds-date-range-input-state-icon"
          name="fa-regular fa-lock"
        />
      }
      @if (pending()) {
        <soft-ds-icon
          class="soft-ds-date-range-input-state-icon"
          name="fa-regular fa-spinner fa-spin"
        />
      }
    </div>
  </div>
  @if (hasValidationErrors) {
    <soft-validation-container class="soft-property-validation" [errors]="errors()" />
  }
</div>
